import React, { Fragment, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { useLanguage } from '../../../../context/LanguageProvider';
import { NepNowDateFormat } from '../../../../constants/DateFormat';
import AppURL from '../../../../constants/AppURL';
import { formatMoney_2, NumberToNepaliNum } from '../../../../helpers/DateFormat';

interface PLRptPrintProps {
    onProfitLossReport: any;
}
const PrintProfitLossRptView: React.FC<PLRptPrintProps> = ({ onProfitLossReport }) => {
    const { SOFTWARE_ORG, ACCOUNT_RPT_DATE } = useSelector((state: RootState) => state.software);
    const org_details = SOFTWARE_ORG?.org;
    const date_report = ACCOUNT_RPT_DATE.acc_rpt;
    const { language } = useLanguage();
    const [totalAmt, setOnTotalAmt] = useState({ totalpartiAmt: 0, totalCRYearAmt: 0 })
    useEffect(() => {
        if (onProfitLossReport?.results) {
            const totalPartAmount = onProfitLossReport.results.reduce((total: any, voucher: any) => {
                return total + (voucher.particuamt || 0);
            }, 0);

            const totalCRYearAmount = onProfitLossReport.results.reduce((total: any, voucher: any) => {
                return total + (voucher.currentyear || 0);
            }, 0);

            setOnTotalAmt({ totalpartiAmt: totalPartAmount, totalCRYearAmt: totalCRYearAmount });
        }
    }, [onProfitLossReport]);

    const DateNow = NepNowDateFormat();
    return (
        <Fragment>
            <style>
                {`@media print {
                    @page {
                        size: A4 landscape;
                        margin: 0.2in;
                        border: 1px solid oklch(0.145 0 0); 
                        page-break-before: always;
                    }
                }
            `}
            </style>
            <div className='bg-white h-screen'>
                <div className="relative border border-gray-300 p-0.5">
                    <table className="w-full text-sm text-left rtl:text-right text-black">
                        <tbody>
                            <tr>
                                <td className={`w-[25%] text-[12px] text-black whitespace-nowrap ${language === "Eng" ? "font-public-sans" : "font-nepali"}`} >
                                    {language === "Eng" ? "S. Code: " : "एस. कोड:"}:  {language === "Eng" ? org_details?.org_reg : NumberToNepaliNum(org_details?.org_reg || "")}
                                </td>
                                <td className="w-[25%]">
                                </td>
                                <td className="w-[25%]">
                                </td>
                                <td align='right' className={`w-[25%] text-[12px] text-black whitespace-nowrap ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                    {language === "Eng" ? "Phone: " : "फोन नम्बर:"}  {language === "Eng" ? org_details?.org_phone : NumberToNepaliNum(org_details?.org_phone || 0)}
                                </td>
                            </tr>
                            <tr >
                                <td rowSpan={4} className="w-[25%] font-medium text-black whitespace-nowrap dark:text-white">
                                    <img width={60} height={60} src={AppURL.BaseURL + org_details?.logo} alt="" />
                                </td>
                                <td align='center' colSpan={2} className={`w-[25%] text-black font-bold text-[18px] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                    {language === "Eng" ? org_details?.org_name : org_details?.org_name_nep}
                                </td>
                                <td className="w-[25%]">
                                </td>
                            </tr>
                            <tr >
                                <td align='center' colSpan={2} className={`w-[25%] text-black font-normal text-[12px] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                    {language === "Eng" ? org_details?.org_add : org_details?.org_add_nep}
                                </td>
                                <td align='right' className={`w-[25%] text-[11px] text-black font-normal ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                    {language === "Eng" ? "Date: " : "मिति: "} {language === "Eng" ? DateNow : NumberToNepaliNum(DateNow)}
                                </td>
                            </tr>
                            <tr >
                                <td align='center' colSpan={2} className={`w-[25%] underline text-black text-[15px] ${language === "Eng" ? "font-public-sans font-medium" : "font-nepali font-thin"}`}>
                                    {language === "Eng" ? "Trial Report" : "नाफा/नोक्सान रिपोर्ट"}
                                </td>
                                <td className="w-[25%]">
                                </td>
                            </tr>
                            <tr>
                                <td align='center' colSpan={2} className={`w-[25%] text-black font-light text-[11px] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                    {language === "Eng" ? "Date: " : "मिति: "}
                                    {language ? date_report?.date_from : NumberToNepaliNum(date_report?.date_from || 0)} {language === "Eng" ? "from " : "बाट "} {language ? date_report?.date_from : NumberToNepaliNum(date_report?.date_to || 0)} {language === "Eng" ? "Upto " : "सम्म"}
                                </td>
                                <td align='right' className="w-[25%] text-[11px]">
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className={`relative`}>
                    <table className="w-full text-left rtl:text-right text-black ">
                        <thead className="text-[11px]  font-light text-gray700 bg-slate-100 dark:bg-sky-950 capitalize border-b dark:bg-slate900 dark:text-slate-400">
                            <tr>
                                <th scope="col" align='center' className={`px-1 border border-slate-300 dark:border-sky-800 w-[8%] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                    {language === "Eng" ? "S.N." : "स.नं."}
                                </th>

                                <th scope="col" align='center' className={`px-1 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                    {language === "Eng" ? "Particulars" : "विवरण"}
                                </th>
                                <th scope="col" align='center' className={`px-1 border border-slate-300 dark:border-sky-800 w-[25%] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                    {language === "Eng" ? "Current Year" : "चालू वर्ष"}
                                </th>

                            </tr>

                        </thead>
                        <tbody className={`text-slate-800 text-[11px] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                            {Array.isArray(onProfitLossReport?.results) &&
                                onProfitLossReport?.results?.map((ledger: any, index: number) =>
                                (
                                    <tr key={index}>
                                        <td align='center' className={`px-1 border border-gray-300 font-light dark:border-sky-800 capitalize ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                            {language === "Eng" ? index + 1 : NumberToNepaliNum(index + 1)}.
                                        </td>
                                        <td align='left' className={`px-1 border border-gray-300 font-light dark:border-sky-800 w-[50%] capitalize ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                            <span className='font-bold underline-offset-1'>{language === "Eng" ? ledger?.subledgname : ledger?.subledgnamenep}</span>
                                            {ledger?.particuid && (
                                                <div className='flex justify-between'>
                                                    <span className='pl-9 font-normal'>{language === "Eng" ? ledger?.particularname : ledger?.particunamenep}</span>
                                                    <span className='pl-9 font-normal'>{language === "Eng" ? formatMoney_2(ledger?.particuamt || 0) : NumberToNepaliNum(formatMoney_2(ledger?.particuamt || 0))}</span>
                                                </div>
                                            )}
                                        </td>

                                        <td align='right' className={`px-1 border border-gray-300 font-light dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                            {language === "Eng" ? formatMoney_2(ledger?.currentyear || 0) : NumberToNepaliNum(formatMoney_2(ledger?.currentyear || 0))}
                                        </td>

                                    </tr>
                                )
                                )
                            }
                            <tr className='text-[11px] text-black bg-gray100'>
                                <td align='right' colSpan={1} className={`px-1 font-bold border border-gray-300 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                    {language === "Eng" ? "Total Amount" : "कुल रकम"}
                                </td>
                                <td align='right' colSpan={1} className={`px-1 font-bold border border-gray-300 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                    {language === "Eng" ? formatMoney_2(totalAmt?.totalpartiAmt || 0) : NumberToNepaliNum(formatMoney_2(totalAmt?.totalpartiAmt || 0))}
                                </td>
                                <td align='right' colSpan={1} className={`px-1 font-bold border border-gray-300 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                    {language === "Eng" ? formatMoney_2(totalAmt?.totalCRYearAmt || 0) : NumberToNepaliNum(formatMoney_2(totalAmt?.totalCRYearAmt || 0))}
                                </td>

                            </tr>
                        </tbody>
                    </table>
                </div>
                <br />
            </div >
        </Fragment>

    )
}

export default PrintProfitLossRptView

